import DatePicker from "react-datetime";

export const SingleDatePicker = ({
  value,
  filterByDateRange,
  name,
  dateFormat,
  isValidDate,
}) => {
  return (
    <div className="single-date-picker">
      <i className="fa fa-calendar fa-xs calendar-icon" aria-hidden="true"></i>
      <DatePicker
        value={value}
        name={name}
        closeOnSelect={true}
        dateFormat={dateFormat}
        timeFormat={false}
        onChange={(e) => filterByDateRange(e, name)}
        isValidDate={isValidDate || (() => true)} // Default to always valid
      />
    </div>
  );
};
